import React, { useEffect, useState } from "react";
import {
	IonInput,
	IonItem,
	IonLabel,
	IonSelect,
	IonSelectOption,
	IonCol,
	IonGrid,
	IonRow,
	IonIcon,
	IonText,
	IonButton,
	useIonAlert,
	IonButtons,
	IonContent,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonToolbar,
	IonRadioGroup,
	IonRadio,
	IonDatetimeButton,
	IonModal,
	IonDatetime,
	IonBackButton
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Date, Phone } from "../../controls";
import { arrowBackOutline, checkmarkCircleOutline } from "ionicons/icons";
import moment from "moment";
import useStore from "../../store/store";
import BackButton from "../../components/BackButton";
import "../../controls/Radio.css";
import AnimatedPage from "../AnimatedPage";
import validator from "validator";

const StartRenting: React.FC = (props: any) => {
	const { t } = useTranslation();
	let [address, setAddress] = useState<string>("");
	let [lat, setLat] = useState<string>("");
	let [lng, setLng] = useState<string>("");
	let [tenantId, setTenantId] = useState<string>("");
	let [status, setStatus] = useState<string>("");
	let [city, setCity] = useState<string>("");
	let [province, setProvince] = useState<string>("");
	let [zipCode, setZipCode] = useState<string>("");
	let [rent, setRent] = useState<string>("");
	let [error, setError] = useState<string>("");
	let [msg, setMsg] = useState<string>("");
	let [toEditId, setToEditId] = useState<string>("");
	const [tenantsList, setTenantsList] = useState<any[]>([]);
	const history = useHistory();
	let [isDisabled, setIsDisabled] = useState<boolean>(false);
	const [tenantType, setTenantType] = useState("existing");
	const [rentingDate, setRentingDate] = useState(
		moment().format("YYYY-MM-DD")
	);
	let [name, setName] = useState<string>("");
	let [email, setEmail] = useState<string>("");
	let [phone, setPhone] = useState<string>("");
	const { setIsLoading, token } = useStore((state: any) => state);

	useEffect(() => {
		getTenantsData();
	}, []);

	const getTenantsData = () => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/tenants/all`,
				{
					keyword: ""
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				setTenantsList(res.data);
			})
			.catch(err => console.log(err));
	};

	const submitData = () => {
		const id = props.match.params.propertyId;
		if (!id) return;

		if (!rent) {
			setError(t("addAmountError") || "");
			return;
		}
		if (!rentingDate) {
			setError(t("requiredRentingDate") || "");
			return;
		}

		if (tenantType === "existing") {
			if (tenantId === "") {
				setError(t("selectTenant") || "");
				return;
			}
		}

		if (tenantType === "new") {
			if (name === "") {
				setError(t("requiredName") || "");
				return;
			}
			if (phone === "") {
				setError(t("requiredPhone") || "");
				return;
			}

			if (email !== "") {
				if (!validator.isEmail(email)) {
					setError(t("validEmail") || "");
					return;
				}
			}
		}

		setIsLoading(true);
		setIsDisabled(true);

		let obj = {
			rent,
			rentingDate,
			tenantType,
			tenantId,
			name,
			phone,
			email
		};

		axios
			.put(
				`${process.env.REACT_APP_API_URL}/properties/start/${id}`,
				obj,
				{ headers: { rentapp_auth: token } }
			)
			.then(res => {
				setMsg(t("propertyDataAdded") || "");
				clearForm();
				setIsDisabled(false);
				setIsLoading(false);
				history.push("/properties");
			})
			.catch(err => {
				setError(err.response.message);
				setIsLoading(false);
				setIsDisabled(false);
			});
	};

	const clearForm = () => {
		setError("");
		setRent("");
		setName("");
		setEmail("");
		setPhone("");
	};

	return (
		<IonPage>
			<AnimatedPage>
				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonMenuButton />
						</IonButtons>
						<IonTitle>{t("startRenting")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonButtons slot="start">
								<IonBackButton
									text=""
									icon={arrowBackOutline}
									defaultHref="/properties"
									style={{ marginLeft: 10 }}
								/>
							</IonButtons>
							<IonTitle size="large" style={{ marginLeft: 40 }}>
								{t("startRenting")}
							</IonTitle>
						</IonToolbar>
					</IonHeader>
					<IonGrid>
						<IonRow>
							<IonCol
								size-sm="12"
								size-xs="12"
								size-md="6"
								size-lg="6"
							>
								<IonItem>
									<IonLabel position="fixed">
										{t("rent")}
									</IonLabel>
									<IonInput
										placeholder={t("currencySymbol") || ""}
										value={rent}
										type="number"
										onIonInput={(e: any) =>
											setRent(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol
								size-sm="12"
								size-xs="12"
								size-md="6"
								size-lg="6"
							>
								<IonItem>
									<IonLabel>{t("rentingDate")}</IonLabel>
									<Date
										showLabel={false}
										label={t("rentingDate")}
										id="renting-date"
										value={rentingDate}
										onChange={(e: any) =>
											setRentingDate(e.target.value)
										}
									/>
								</IonItem>
							</IonCol>
							<IonCol
								size-sm="12"
								size-xs="12"
								size-md="6"
								size-lg="6"
							>
								<IonItem>
									<IonLabel>{t("chooseTenant")}</IonLabel>
								</IonItem>
								<IonRadioGroup value={tenantType}>
									<IonItem
										onClick={e => setTenantType("existing")}
									>
										<IonLabel style={{ fontSize: 13 }}>
											{t("existing")}
										</IonLabel>
										<IonRadio
											slot="end"
											value="existing"
										></IonRadio>
									</IonItem>
									<IonItem
										onClick={e => setTenantType("new")}
									>
										<IonLabel style={{ fontSize: 13 }}>
											{t("new")}
										</IonLabel>
										<IonRadio
											slot="end"
											value="new"
										></IonRadio>
									</IonItem>
								</IonRadioGroup>
							</IonCol>
							{tenantType === "existing" && (
								<IonCol
									size-sm="12"
									size-xs="12"
									size-md="6"
									size-lg="6"
								>
									<IonItem>
										<IonLabel position="fixed">
											{t("tenant")}
										</IonLabel>
										<IonSelect
											placeholder={t("tenant") || ""}
											value={tenantId}
											onIonChange={(e: any) =>
												setTenantId(e.target.value)
											}
											okText={t("ok") || "Yes"}
											cancelText={t("cancel") || "Cancel"}
										>
											{tenantsList.map((elem, index) => {
												return (
													<IonSelectOption
														value={elem._id}
														key={index}
													>
														{elem.name}
													</IonSelectOption>
												);
											})}
										</IonSelect>
									</IonItem>
								</IonCol>
							)}
							{tenantType === "new" && (
								<>
									<IonCol
										size-sm="12"
										size-xs="12"
										size-md="6"
										size-lg="6"
									>
										<IonItem>
											<IonLabel position="fixed">
												{t("name")}
											</IonLabel>
											<IonInput
												placeholder={t("name") || ""}
												value={name}
												onIonInput={(e: any) =>
													setName(e.target.value)
												}
												onKeyUp={() => {
													setError("");
													setMsg("");
												}}
											></IonInput>
										</IonItem>
									</IonCol>
									<IonCol
										size-sm="12"
										size-xs="12"
										size-md="6"
										size-lg="6"
									>
										<IonItem>
											<IonLabel position="fixed">
												{t("email")}
											</IonLabel>
											<IonInput
												placeholder={t("email") || ""}
												value={email}
												onIonInput={(e: any) =>
													setEmail(e.target.value)
												}
												onKeyUp={() => {
													setError("");
													setMsg("");
												}}
											></IonInput>
										</IonItem>
									</IonCol>
									<IonCol
										size-sm="12"
										size-xs="12"
										size-md="6"
										size-lg="6"
									>
										<Phone
											label={t("phone")}
											value={phone}
											onChange={setPhone}
											labelPosition="fixed"
										/>
									</IonCol>
								</>
							)}
							<IonCol size="12" className="ion-text-center">
								<Button
									text={t("startRenting")}
									icon={checkmarkCircleOutline}
									onClick={submitData}
									disabled={isDisabled}
								/>
							</IonCol>
							<IonCol size="12">
								<IonText color="danger">{error}</IonText>
								<IonText color="success">{msg}</IonText>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonContent>
			</AnimatedPage>
		</IonPage>
	);
};

export default StartRenting;
